import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/(private)/documents/')({
	beforeLoad: () => {
		throw redirect({ to: '/', search: true, replace: true })
	}
})
